<script>

/**
 * Credit for formats goes to darkain, https://github.com/darkain/php-tracking-urls/blob/main/php-tracking-urls.php
 */
const TRACKING_NUMBER_FORMATS = [
    //UPS - UNITED PARCEL SERVICE
    {
        url: 'http://wwwapps.ups.com/WebTracking/processInputRequest?TypeOfInquiryNumber=T&InquiryNumber1=',
        pattern: /\b(1Z ?[0-9A-Z]{3} ?[0-9A-Z]{3} ?[0-9A-Z]{2} ?[0-9A-Z]{4} ?[0-9A-Z]{3} ?[0-9A-Z]|T\d{3} ?\d{4} ?\d{3})\b/i
    },

    //USPS - UNITED STATES POSTAL SERVICE - FORMAT 1
    {
        url: 'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=',
        pattern: /\b((420 ?\d{5} ?)?(91|92|93|94|95|01|03|04|70|23|13)\d{2} ?\d{4} ?\d{4} ?\d{4} ?\d{4}( ?\d{2,6})?)\b/i
    },

    //USPS - UNITED STATES POSTAL SERVICE - FORMAT 2
    {
        url: 'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=',
        pattern: /\b((M|P[A-Z]?|D[C-Z]|LK|E[A-C]|V[A-Z]|R[A-Z]|CP|CJ|LC|LJ) ?\d{3} ?\d{3} ?\d{3} ?[A-Z]?[A-Z]?)\b/i
    },

    //USPS - UNITED STATES POSTAL SERVICE - FORMAT 3
    {
        url: 'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=',
        pattern: /\b(82 ?\d{3} ?\d{3} ?\d{2})\b/i
    },

    //FEDEX - FEDERAL EXPRESS
    {
        url: 'https://www.fedex.com/fedextrack/?trknbr=',
        pattern: /\b(((96\d\d|6\d)\d{3} ?\d{4}|96\d{2}|\d{4}) ?\d{4} ?\d{4}( ?\d{3})?)\b/i
    },

    //ONTRAC
    // Disabled as it might conflict with a freight shipper
    //{
    //    url: 'http://www.ontrac.com/trackres.asp?tracking_number=',
    //    pattern: /\b(C\d{14})\b/i
    //},

    //DHL
    // Disabled as I'm pretty sure this conflicts with a freight shipper
    //{
    //    url: 'http://www.dhl.com/content/g0/en/express/tracking.shtml?brand=DHL&AWB=',
    //    pattern: /\b(\d{4}[- ]?\d{4}[- ]?\d{2}|\d{3}[- ]?\d{8}|[A-Z]{3}\d{7})\b/i
    //},
]

export default {
    props: {
        number: {
            type: String,
            required: true
        },
    },
    computed: {
        url() {
            for (let carrier of TRACKING_NUMBER_FORMATS) {
                if (carrier.pattern.test(this.number)) {
                    return `${carrier.url}${this.number.trim()}`
                }
            }
            return false
        }
    },

    render(createElement) {
        if (this.url) {
            return createElement('a', { attrs: { href: this.url } }, this.number)
        } else {
            return createElement('span', this.number)
        }
    },
}
</script>
